import React from "react";
import { makeStyles, Typography, Grid, Container } from "@material-ui/core";
import TestimonialsDataController from "./TestimonialsDataController";
import TestimonialsCard from "../common/TestimoninalsCard";
import NavButton from "../common/NavButton";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    marginTop: "7.4rem",
    marginBottom: "7rem",
  },
  subHeader: {
    marginTop: "1em",
  },
  cardList: {
    marginTop: "6.625rem",
    [theme.breakpoints.only("xs")]: {
      marginTop: "3.625rem",
    },
  },
  alignCards: {
    [theme.breakpoints.only("xs")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

const Testimonials = ({ name }) => {
  const classes = useStyles();

  const presentedArray = TestimonialsDataController(name);
  const dataText = presentedArray.dataText;
  const dataCard = presentedArray.dataCard;
  const next = presentedArray.next;
  const prev = presentedArray.prev;

  const SM_BREAKPOINT = 600;
  const MAX_CARD_DISPLAY = presentedArray.width < SM_BREAKPOINT ? 1 : 3;

  let data =
    presentedArray.width < SM_BREAKPOINT
      ? presentedArray.dataSmallScreen
      : presentedArray.dataBigScreen;

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Typography variant="h1" color="primary">
        {dataText.header}
      </Typography>

      {dataText.subHeader && (
        <Typography color="textSecondary" className={classes.subHeader}>
          {dataText.subHeader}
        </Typography>
      )}

      <Container className={classes.cardList}>
        <div className="testimonials">
          <Grid container spacing={5}>
            {data.map((data, i) => (
              <Grid
                item
                md={4}
                sm={6}
                xs={12}
                className={classes.alignCards}
                key={i}
              >
                <TestimonialsCard
                  person={data.person}
                  msg={data.msg}
                  job={data.job}
                  avatar={data.avatar}
                />
              </Grid>
            ))}
          </Grid>

          {dataCard.length > MAX_CARD_DISPLAY ? (
            <NavButton prev={prev} next={next} />
          ) : null}
        </div>
      </Container>
    </Container>
  );
};

export default Testimonials;
